import type { CityConfig } from "../city-template/types";

export const medinaConfig: CityConfig = {
  city: "Medina",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "medina",
  route: "/medina",
  title: "Emergency Passport Medina, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Medina, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Medina County and southwest Cleveland suburbs. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Medina, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Medina and southwest Cleveland area travelers — including Brunswick and Wadsworth — get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Medina%20Ohio%20historic%20downtown%20square%20with%20the%20iconic%20Victorian-era%20courthouse%2C%20charming%20small%20town%20main%20street%20with%20boutique%20shops%20and%20cafes%2C%20warm%20golden%20hour%20light%20on%20historic%20brick%20buildings%2C%20beautiful%20tree-lined%20public%20square%20with%20well-preserved%20architecture%2C%20professional%20photography%20with%20warm%20earth%20tones%20and%20a%20peaceful%20atmosphere%2C%20southwest%20Cleveland%20suburb%20setting&width=1800&height=700&seq=medina-oh-hero-001&orientation=landscape",
  heroImageAlt: "Medina Ohio historic downtown square with Victorian courthouse",
  geoPosition: "41.1384;-81.8638",
  geoPlacename: "Medina, Ohio",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 250 miles from Medina via I-80",
  },
  nearbyCitiesZips: [
    { name: "Medina", zips: "44256" },
    { name: "Brunswick", zips: "44212" },
    { name: "Wadsworth", zips: "44281" },
    { name: "Strongsville", zips: "44136, 44149" },
    { name: "Berea", zips: "44017" },
    { name: "Middleburg Heights", zips: "44130" },
    { name: "North Royalton", zips: "44133" },
    { name: "Rittman", zips: "44270" },
    { name: "Lodi", zips: "44254" },
    { name: "Seville", zips: "44273" },
    { name: "Chippewa Lake", zips: "44215" },
    { name: "Creston", zips: "44217" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Medina departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-global-line", title: "Medina County Coverage", desc: "Serving Medina County and southwest Cleveland suburbs" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Cleveland, OH", route: "/cleveland" },
    { name: "Fast passport renewal in Akron, OH", route: "/akron" },
    { name: "Emergency passport help in Canton, OH", route: "/canton" },
    { name: "Urgent passport services in Lorain, OH", route: "/lorain" },
    { name: "Same-day passport help in Elyria, OH", route: "/elyria" },
    { name: "Passport courier services in Youngstown, OH", route: "/youngstown" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Medina remotely via secure courier. We do not have a walk-in office in Medina — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Medina County and southwest Cleveland area travelers.",
  fpcOfficeDistance: "Serving all of Medina County and southwest Cleveland suburbs",
  fpcOfficeAddress: "175 S Third St, Ste 200, Columbus, Ohio 43215",
  serviceAreaIntro: "From downtown Medina to Brunswick and Wadsworth, from Strongsville to Berea and Middleburg Heights — Fast Passport Center serves the entire Medina County and southwest Cleveland region. We regularly help travelers from North Royalton, Rittman, and Lodi get their passports fast.",
  nearbyCitiesIntro: "We serve all Medina neighborhoods and the surrounding Medina County and southwest Cleveland region including Brunswick, Wadsworth, Strongsville, Berea, Middleburg Heights, North Royalton, Rittman, Lodi, Seville, Chippewa Lake, and Creston. If you are anywhere in the Medina area or southwest Cleveland suburbs, we have you covered.",
  howItWorksIntro: "Most Medina travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Medina travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Medina and Medina County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Medina? Here are the most common ones we hear from Medina County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Medina international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Karen J.",
      location: "Medina, OH",
      rating: 5,
      text: "My passport expired two weeks before our family trip to Italy. Fast Passport Center had my renewal ready in 4 days. They were incredibly helpful and made the process so easy.",
      service: "Passport Renewal",
    },
    {
      name: "Michael R.",
      location: "Brunswick, OH",
      rating: 5,
      text: "Emergency business trip to London came up with only 3 days notice. Fast Passport Center got my passport processed in 30 hours. I was impressed with their professionalism.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah H.",
      location: "Wadsworth, OH",
      rating: 5,
      text: "Applied for my daughter's first passport for our cruise to the Bahamas. They guided us through every document and had her passport ready in 5 days. Wonderful service.",
      service: "Child Passport",
    },
    {
      name: "Paul T.",
      location: "Strongsville, OH",
      rating: 5,
      text: "Lost my passport the week before my Cancun trip. Fast Passport Center handled the DS-64 form and got me a replacement in 4 days. They saved my vacation.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "medina-1",
      name: "Medina Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "320 W Liberty St",
      city: "Medina",
      state: "OH",
      zip: "44256",
      phone: "(330) 723-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Medina",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main downtown facility. High volume — appointments strongly recommended. Call ahead for availability.",
      icon: "ri-mail-line",
    },
    {
      id: "medina-2",
      name: "Brunswick Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3900 Center Rd",
      city: "Brunswick",
      state: "OH",
      zip: "44212",
      phone: "(330) 225-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Brunswick, 10 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Brunswick and North Royalton residents. Less crowded than downtown. Call for appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "medina-3",
      name: "Wadsworth Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 Maple St",
      city: "Wadsworth",
      state: "OH",
      zip: "44281",
      phone: "(330) 334-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Wadsworth, 12 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Wadsworth and southern Medina County residents. Ample parking. Call ahead for appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "medina-4",
      name: "Strongsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "13200 Pearl Rd",
      city: "Strongsville",
      state: "OH",
      zip: "44136",
      phone: "(440) 238-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Strongsville, 15 miles northeast",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for northeast Medina and Cuyahoga County residents. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "medina-5",
      name: "Medina County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "93 Public Square",
      city: "Medina",
      state: "OH",
      zip: "44256",
      phone: "(330) 725-9728",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Medina County Courthouse",
      website: "https://www.co.medina.oh.us/",
      websiteLabel: "Medina County Courts",
      notes: "Accepts passport applications. Good alternative to post office with extended hours and appointment availability.",
      icon: "ri-government-line",
    },
    {
      id: "medina-6",
      name: "Berea Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2 Seminary St",
      city: "Berea",
      state: "OH",
      zip: "44017",
      phone: "(440) 234-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Berea, 18 miles northeast",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Berea and Cuyahoga County residents east of Medina. Call for appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Medina photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Medina County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Medina applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Medina County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Medina travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Medina." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Medina address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Medina before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Medina for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4 hour drive to Chicago." },
    { q: "How fast can I renew my passport in Medina?", a: "Fast Passport Center offers fast passport renewal in Medina in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "Can I get a same-day passport appointment near Medina?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 250 miles from Medina via I-80 — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Medina County residents." },
    { q: "Can I expedite a child passport in Medina?", a: "Yes. Fast Passport Center expedites child passports in Medina for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Medina County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Medina with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "What is the closest passport agency to Medina?", a: "The nearest regional passport agency to Medina is the Chicago Passport Agency, approximately 250 miles away via I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Medina without any in-person agency visit required." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Can you help travelers from Brunswick and Wadsworth?", a: "Absolutely. Fast Passport Center serves all of Medina County and the surrounding southwest Cleveland region including Brunswick, Wadsworth, Strongsville, Berea, Middleburg Heights, North Royalton, Rittman, Lodi, Seville, Chippewa Lake, and Creston. Our courier service works seamlessly from any zip code in the area." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Medina", address: "1100 N Court St, Medina, OH 44256", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Medina", address: "1000 N Jefferson St, Medina, OH 44256", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Medina", address: "4141 Pearl Rd, Medina, OH 44256", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Medina", address: "200 S Broadway St, Medina, OH 44256", hours: "Mon–Sun: 9AM–9PM" },
    { name: "CVS Pharmacy — Brunswick", address: "3900 Center Rd, Brunswick, OH 44212", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Wadsworth", address: "120 Maple St, Wadsworth, OH 44281", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Strongsville", address: "13200 Pearl Rd, Strongsville, OH 44136", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Berea", address: "2 Seminary St, Berea, OH 44017", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "Medina BMV — Medina County",
      address: "1100 N Court St, Medina, OH 44256",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "Brunswick BMV — Medina County",
      address: "3900 Center Rd, Brunswick, OH 44212",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Medina County driver's license and REAL ID services. Alternative for north Medina residents.",
      featured: false,
    },
    {
      name: "Wadsworth BMV — Medina County",
      address: "120 Maple St, Wadsworth, OH 44281",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Medina County BMV. Alternative for south Medina and Wadsworth area residents.",
      featured: false,
    },
    {
      name: "Strongsville BMV — Cuyahoga County",
      address: "13200 Pearl Rd, Strongsville, OH 44136",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Cuyahoga County BMV. Alternative for northeast Medina and Strongsville area residents.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CLE",
      name: "Cleveland Hopkins International Airport",
      distance: "25 miles northeast of Medina",
      address: "5300 Riverside Dr, Cleveland, OH 44135",
      note: "Nearest major commercial airport with direct flights to major hubs. Primary airport for Medina County international travelers.",
      flightUrl: "https://www.clevelandairport.com/",
      flightLabel: "Cleveland Airport",
      featured: true,
    },
    {
      code: "CAK",
      name: "Akron-Canton Airport",
      distance: "30 miles southeast of Medina",
      address: "5400 Lauby Rd, North Canton, OH 44720",
      note: "Alternative airport for southeast Medina. Additional flight options and sometimes easier parking.",
      flightUrl: "https://www.akroncantonairport.com/",
      flightLabel: "Akron-Canton Airport",
      featured: false,
    },
    {
      code: "CLE",
      name: "Burke Lakefront Airport",
      distance: "30 miles northeast of Medina",
      address: "1501 N Marginal Rd, Cleveland, OH 44114",
      note: "General aviation airport in downtown Cleveland. Charter and private flight options available.",
      flightUrl: "https://www.clevelandairport.com/burke",
      flightLabel: "Burke Lakefront Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Ohio Department of Health Vital Statistics. Online, mail, or in-person options for Medina County residents.", url: "https://odh.ohio.gov/know-our-programs/vital-statistics" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through ODH Vital Statistics. Required for estate, insurance, and legal matters.", url: "https://odh.ohio.gov/know-our-programs/vital-statistics" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Medina County Probate Court. Certified copies available for name changes.", url: "https://www.medinacountyprobate.org/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Medina County Clerk of Courts. Required for name change passport corrections.", url: "https://www.co.medina.oh.us/" },
  ],
};